import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Solution() {
  const {
    t
  } = useLanguage();
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet relative overflow-hidden" data-id="element-261">
      <div className="gold-spotlight-top" aria-hidden="true" data-id="element-262" />
      <div className="gold-spotlight-center" aria-hidden="true" data-id="element-263" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-264">
        <div className="max-w-4xl mx-auto text-center" data-id="element-265">
          <SectionHeading title={`${t.solution.title1}<span class='font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle ml-1'>${t.solution.titleHighlight}</span>`} data-id="element-266" />

          <div className="space-y-8 font-sans text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-267">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-268">
              {t.solution.p1}
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-269">
              {t.solution.p2}
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-270">
              {t.solution.p3}
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-271">
              {t.solution.p4}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="surface-elevated rounded-sm px-6 md:px-10 py-10 md:py-12 my-12" data-id="element-272">
              <p className="gold-shine font-script font-semibold text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-273">
                {t.solution.p5_1}
                <span className="font-allura font-normal text-4xl md:text-5xl lg:text-6xl align-middle mx-1" data-id="element-274">
                  {t.solution.p5_highlight}
                </span>
                {t.solution.p5_2}
              </p>
              <p className="gold-shine-soft font-allura text-4xl md:text-5xl mt-6" data-id="element-275">
                Riam Beauty Studio
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}